import { IPostCategory, RequestType } from "../types/IPostCategory";
import { PostCategoryGroupsResponse } from "../types/IPostCategoryGroup";
import { Headers } from "../types/Headers";
import { apiv4 } from "./axios";
import { City } from "../types/CityStateCountry";
import { Coordinates } from "../types/Coordinates";
import { GetSignedUrlProps } from "../types/GetSignedS3Url";

type SignedUrl = {
  signedRequest: string;
  url: string;
};

export type NearbyPost = {
  id: number;
  address: string;
  neighborhood: string;
  description: string;
  photoUrl?: string;
  lat: number;
  lng: number;
};

export const postCategories = async (decryptedHeaders: Headers) => {
  const { data } = await apiv4.get<RequestType>("/post-categories", {
    params: {
      where: JSON.stringify({}),
      page: 1,
      pageSize: 10,
      paginate: false,
      withDeleted: false,
    },
    headers: decryptedHeaders,
  });

  return data;
};

export const getPostCategoriesWithGroups = async (headers: Headers) => {
  const { data } = await apiv4.get<PostCategoryGroupsResponse>(
    "/post-categories/with-groups",
    { headers }
  );

  return data;
};

export const getPostCategoryById = async (
  id: number,
  decryptedHeaders: Headers
): Promise<IPostCategory> => {
  const { data } = await apiv4.get<IPostCategory>(`/post-categories/${id}`, {
    headers: decryptedHeaders,
  });
  return data;
};

export const getNearbyPosts = async (
  categoryId: number,
  lat: number,
  lng: number,
  decryptedHeaders: Headers
): Promise<NearbyPost[]> => {
  const { data } = await apiv4.get<NearbyPost[]>(
    `/post-categories/${categoryId}/nearby-posts`,
    {
      params: { lat, lng },
      headers: decryptedHeaders,
    }
  );
  return data;
};

export const getCitizenCityPosition = async (headers: Headers) => {
  const [{ data: cities }, { data: coordinates }] = await Promise.all([
    apiv4.get<Array<City>>('/cities/admin-user-cities', { headers }),
    apiv4.get<Coordinates>('/cities/coordinates', { headers }),
  ]);

  const [city] = cities;
  return { city, coordinates, cities };
};

export const getSignedUrl = async (param: GetSignedUrlProps) => {
  const { headers, ...params } = param;
  const { data } = await apiv4.get<SignedUrl>('/integration/aws/s3-signed-url', {
    params,
    headers,
  });

  return { signedUrl: data };
};